export enum DemoEvents {
  DemoSignupModalOpen = 'DemoSignupModalOpen',
  DemoSignupClick = 'DemoSignupClick',
}
